import React from 'react';
import {OverlayTrigger, Popover} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";

const InfoIcon = ({text, overlay = undefined, iconOptions = undefined, size = undefined, ...props}) => {

    if(!overlay)
    {
        //overlay = (<Tooltip id="button-tooltip-2">{text}</Tooltip>)
        overlay = (<Popover id="popover-basic">
            <Popover.Body>
                {text}
            </Popover.Body>
        </Popover>)
    }

    if(!iconOptions) //Not provide at all
    {
        iconOptions = {
            icon: faCircleInfo,
            color: 'rgb(80, 80, 80)',
            transform: ''
        };
    }
    else //Probably partially provided
    {
        if(!iconOptions.icon)
            iconOptions = {...iconOptions, icon: faCircleInfo};
        if(!iconOptions.color)
            iconOptions = {...iconOptions, color: 'black'};
        if(!iconOptions.transform)
            iconOptions = {...iconOptions, transform: ''};
    }


    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 200, hide: 200 }}
            overlay={overlay}
        >
            <span {...props}>
                <FontAwesomeIcon icon={iconOptions.icon} color={iconOptions.color} transform={iconOptions.transform} size={size ? size : null}/>
            </span>
        </OverlayTrigger>
    );
};

export default InfoIcon;